import { Component, Prop, Lifecycle } from "vuety";
import { IProductGroupItem } from "../../interfaces";
import { ListList } from "./listList";
import { BaseView } from "../base";
import Vue from "vue";

const templateElement = "v-tmpl-grouplistitem";

@Component({
	template: document.getElementById(templateElement) ? "#" + templateElement : require("./listItem.html"),
	name: "list-item",
	mixins: [BaseView],
})
export class ListItem extends Vue {
	@Prop() public group: IProductGroupItem;
	@Prop() public parentGroupCode: string;

	@Lifecycle()
	beforeCreate() {
		if (this.$options && this.$options.components) {
			this.$options.components["ListList"] = ListList;
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/list/listItem.ts